import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/webfonts/all.min.css'
import { Provider } from 'react-redux';
import store from './Redux/store';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import './index.css';

    

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<div>
<Provider store={store}>
 <App />
 </Provider>
 </div>
    
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
